import { CHALLENGES, MAIN, PROCEDURE_GAME, TASK } from '../states/names';

export const BATH_STATES = [MAIN, PROCEDURE_GAME, TASK, CHALLENGES];
